import type { FilterSortSettings } from 'webapp/models-custom/filter-sort/base';
import FilterSortGoal from 'webapp/models-custom/filter-sort/goal';
import type Goal from 'webapp/models-custom/goal';

export const viewSettingsNamePrefix = 'goalsInMobileViewSettings';
export const settingsNamePrefix = 'goalsInMobileFilterSettings'; // used to save filter preferences

export default class FilterSortGoalOnMobile extends FilterSortGoal {
	viewSettingsNamePrefix = viewSettingsNamePrefix;
	settingsNamePrefix = settingsNamePrefix;

	constructor(options: FilterSortSettings<Goal>) {
		super(options);

		this.createFilters();
	}

	override get hideViewSelector(): boolean {
		return true;
	}

	override get hideSearch(): boolean {
		return true;
	}

	createFilters(): void {
		const selectedFilters = this.readSavedSelectedFilters();

		this.createTimeframeFilter(selectedFilters);
	}
}
